export const LANG_TRANSLATOR = {
    ch: '中文',
    tw: '台語',
    hak: '客語',
    frgn: '外語',
    no: '其他＊請填寫於備註',
};
